import { render, staticRenderFns } from "./IdCardConfirm.vue?vue&type=template&id=291f0c38&scoped=true&"
import script from "./IdCardConfirm.vue?vue&type=script&lang=js&"
export * from "./IdCardConfirm.vue?vue&type=script&lang=js&"
import style0 from "./IdCardConfirm.vue?vue&type=style&index=0&id=291f0c38&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "291f0c38",
  null
  
)

export default component.exports